// adminportal/src/types/settings.ts
import { getCompanyName } from '../config';

export type ThemeName = 'default' | 'ocean' | 'sunset' | 'forest' | 'cyberpunk' | 'high-contrast';

export interface ThemeDefinition {
  name: ThemeName;
  displayName: string;
  description: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
}

export const AVAILABLE_THEMES: ThemeDefinition[] = [
  {
    name: 'default',
    displayName: 'Default',
    description: 'Default dark theme',
    primaryColor: '#6366F1',
    secondaryColor: '#0F172A',
    accentColor: '#8B5CF6',
  },
  {
    name: 'ocean',
    displayName: 'Ocean',
    description: 'Blue-green ocean theme',
    primaryColor: '#0891B2',
    secondaryColor: '#0C4A6E',
    accentColor: '#10B981',
  },
  {
    name: 'sunset',
    displayName: 'Sunset',
    description: 'Warm orange sunset theme',
    primaryColor: '#EA580C',
    secondaryColor: '#7C2D12',
    accentColor: '#F59E0B',
  },
  {
    name: 'forest',
    displayName: 'Forest',
    description: 'Natural green forest theme',
    primaryColor: '#059669',
    secondaryColor: '#064E3B',
    accentColor: '#10B981',
  },
  {
    name: 'cyberpunk',
    displayName: 'Cyberpunk',
    description: 'Neon cyberpunk theme',
    primaryColor: '#00FFFF',
    secondaryColor: '#0A0A0A',
    accentColor: '#FF00FF',
  },
  {
    name: 'high-contrast',
    displayName: 'High Contrast',
    description: 'High contrast accessibility theme',
    primaryColor: '#FFFFFF',
    secondaryColor: '#000000',
    accentColor: '#FFFF00',
  },
];

export interface PortalSettings {
  company: {
    name: string;
    theme: ThemeName;
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
    logo: string | null;
    favicon: string | null;
    enableInboundDownloads: boolean;
    enableInboundNotifications: boolean;
    enableOutboundNotifications: boolean;
  };
  title: string;
  subtitle: string;
  system: {
    email: string;
  };
}

export interface SettingsFormData {
  companyName: string;
  theme: ThemeName;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  title: string;
  subtitle: string;
  systemEmail: string;
  favicon: string;
  enableInboundDownloads: boolean;
  enableInboundNotifications: boolean;
  enableOutboundNotifications: boolean;
}

export const DEFAULT_SETTINGS: PortalSettings = {
  company: {
    name: getCompanyName(),
    theme: 'default',
    primaryColor: '#6366F1',
    secondaryColor: '#0F172A',
    accentColor: '#8B5CF6',
    logo: null,
    favicon: null,
    enableInboundDownloads: true,
    enableInboundNotifications: true,
    enableOutboundNotifications: true,
  },
  title: 'NGHS Transfer Portal',
  subtitle: 'Secure Admin Portal for your organization',
  system: {
    email: 'noreply@optimumcloudservices.com',
  },
};
